/**
 * Erreur d'API telle que renvoyée par le socle (`docs/dev/api.md`, § 7) :
 * `{ code, message, details }`, en français. `code` est une constante machine
 * (`galerie_introuvable`, `csrf_requis`…), `message` est destiné à la personne
 * et s'affiche tel quel (2.2 : « les erreurs disent quoi faire »).
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly details: unknown;

  constructor(status: number, code: string, message: string, details: unknown = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/** L'appel n'a pas pu joindre le serveur (réseau coupé, API arrêtée). */
export class ErreurReseau extends Error {
  constructor() {
    super('Impossible de joindre le serveur.');
    this.name = 'ErreurReseau';
  }
}

export function estApiError(valeur: unknown): valeur is ApiError {
  return valeur instanceof ApiError;
}

export function estErreurReseau(valeur: unknown): valeur is ErreurReseau {
  return valeur instanceof ErreurReseau;
}

/** Réponse reçue, mais inexploitable : elle ne prouve aucune révocation. */
export class ErreurReponseIllisible extends Error {}

export function estSessionIndisponible(erreur: unknown): boolean {
  return (
    estErreurReseau(erreur) ||
    erreur instanceof ErreurReponseIllisible ||
    (estApiError(erreur) && erreur.status >= 500)
  );
}
